import { render, staticRenderFns } from "./widget_copy.vue?vue&type=template&id=24aa68aa&scoped=true&lang=pug&"
import script from "./widget_copy.vue?vue&type=script&lang=js&"
export * from "./widget_copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa68aa",
  null
  
)

export default component.exports